"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useEffect, useState } from "react";

export default function DialogDeclineListing({
    open,
    onClose,
    onDecline,
    listingTitle
}) {
    const [declineReason, setDeclineReason] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (open) {
            setDeclineReason('')
            setIsLoading(false)
        }
    }, [open])

    const handleDecline = async () => {
        console.log("=== DIALOG DECLINE CLICKED ===")
        console.log("Decline reason:", declineReason)
        
        if (!declineReason.trim()) {
            console.log("No decline reason provided, returning")
            return
        }

        setIsLoading(true)
        try {
            console.log("Calling onDecline with reason:", declineReason.trim())
            await onDecline(declineReason.trim())
            console.log("onDecline completed successfully")
            onClose()
        } catch (error) {
            console.error('Error declining listing:', error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Dialog open={open} onClose={onClose} className="relative z-[10002]">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden bg-[#181818] rounded-[14px] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-[500px]"
                    >
                        <div className="w-full relative">
                            <button
                                onClick={onClose}
                                className="absolute top-2 right-2 cursor-pointer z-[1]"
                            >
                                <img
                                    src="/assets/icons/icon-close.svg"
                                    alt="Close"
                                    className="invert cursor-pointer"
                                />
                            </button>
                            <div className="p-6 w-full flex flex-col min-h-[400px]">
                                <div className="flex flex-col items-center mb-6">
                                    <img 
                                        src="/assets/icons/icon-warning-circle.svg" 
                                        alt="Warning" 
                                        className="w-[60px] h-[60px] mb-4" 
                                    />
                                    <span className="text-[28px] text-primary text-center">
                                        Decline Listing?
                                    </span>
                                    <span className="text-sm text-white/60 text-center mt-2 max-w-[400px]">
                                        Are you sure you want to decline this listing? Please provide a reason for the decline.
                                    </span>
                                </div>

                                {listingTitle && (
                                    <div className="mb-4 p-3 bg-[#272727] rounded-[10px]">
                                        <span className="text-sm text-white/80">Listing:</span>
                                        <div className="text-white font-medium mt-1">{listingTitle}</div>
                                    </div>
                                )}

                                <div className="mb-6">
                                    <label className="text-sm text-primary mb-2 block">
                                        Decline Reason *
                                    </label>
                                    <textarea
                                        className="w-full rounded-[10px] pl-3 py-3 bg-[#272727] text-white resize-none"
                                        placeholder="Enter the reason for declining this listing..."
                                        value={declineReason}
                                        onChange={(e) => setDeclineReason(e.target.value)}
                                        rows={4}
                                        disabled={isLoading}
                                    />
                                </div>

                                <div className="flex gap-3 mt-auto">
                                    <button
                                        onClick={onClose}
                                        className="flex-1 py-3 text-sm text-white/60 border border-white/20 rounded-[10px]"
                                        disabled={isLoading}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDecline}
                                        disabled={!declineReason.trim() || isLoading}
                                        className={`flex-1 py-3 text-sm rounded-[10px] flex items-center justify-center ${
                                            declineReason.trim() && !isLoading 
                                                ? 'bg-red-500 text-white' 
                                                : 'bg-[#E5E5E5] text-gray-400 cursor-not-allowed'
                                        }`}
                                    >
                                        {isLoading ? (
                                            <>
                                                <img src="/assets/icons/icon-loading.svg" alt="loading" className="w-4 h-4 animate-spin mr-2" />
                                                Declining...
                                            </>
                                        ) : (
                                            'Decline'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
} 